import { formatAmountType } from '../../../../../../utils/format-numbers.utils';
import { CheckedGreen } from '../../../../../../assets/icon/svg';
import Input from '../../../../../ui/input';
import { customStyle, defaultStyle } from '../../../../../../constant/custom-style';
import { RiderGHIRandGAMERRandBB } from '../../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.state';

interface Rider {
    id: number;
    label: string;
}

interface Props {
    riderLabel: string;
    inputLength: number;
    rider: Rider;
    isPreview?: boolean;
    selectedBMSR: RiderGHIRandGAMERRandBB | null
}

export default function AttachableRiderInputBMSR({ selectedBMSR, riderLabel, inputLength, rider, isPreview }: Props) {

    const fAmount = selectedBMSR?.inputs[0]?.fAmount ?? 0;

    return (
        <tr className="group transition-colors hover:bg-blue-50/30">
            <td className="sticky left-0 z-30 min-w-[160px] lg:min-w-[300px] border-b border-gray-200 bg-white px-4 py-3 shadow-[4px_0_10px_rgba(0,0,0,0.03)] group-hover:bg-blue-50">
                <div className="flex min-w-0 items-center gap-2">
                    {isPreview && (
                        <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-green-500 text-white">
                            <CheckedGreen />
                        </div>
                    )}
                    <div className="flex min-w-0 flex-col">
                        <span className="truncate font-medium text-gray-800">
                            {riderLabel}
                        </span>
                        <span className="text-[10px] tracking-wide text-gray-400">
                            Rider Coverage
                        </span>
                    </div>
                </div>
            </td>
            <td colSpan={inputLength} className="border-b border-l border-gray-200 px-2 py-1">
                <Input
                    type="text"
                    value={formatAmountType(fAmount)}
                    readonly={true}
                    isCustomStyle={true}
                    customCss={`cursor-not-allowed ${defaultStyle} ${customStyle}`}
                    onChange={() => {}}
                    required={false}
                    disabled={true}
                />
            </td>
        </tr>
    )
}
